// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-title {
  background-color: #FAFAFA;
  padding: 8px;
  border-radius: 6px;
  color: #181D27;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 40px;
}
@media (max-width: 480px) {
  .section-title {
    flex-direction: column;
    align-items: flex-start;
  }
}
.section-title h4 {
  margin: 0;
  color: #181D27;
  font-size: 16px;
  font-weight: 500;
}
.section-title-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1em;
}
.section-title-actions .form-group {
  margin: 0;
  width: 100%;
}
.section-title .form-panel .section-title {
  display: none;
}
.section-title .form-panel .section-content .control-label {
  display: none;
}
.section-title .form-panel .section-content .form-group {
  margin-bottom: 0;
}
.section-title .form-panel .select2-container {
  min-width: 180px;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/core/SectionTitle/index.less"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;ACDJ;ADII;EAAA;IACI,sBAAA;IACA,uBAAA;ECDN;AACF;ADfA;EAmBQ,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ACDR;ADII;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;ACFR;ADFI;EAOQ,SAAA;EACA,WAAA;ACFZ;AD/BA;EAuCY,aAAA;ACLZ;ADlCA;EA2CgB,aAAA;ACNhB;ADrCA;EA8CgB,gBAAA;ACNhB;ADxCA;EAkDY,gBAAA;ACPZ;AACA,oCAAoC","sourcesContent":["@import '../../../less/variables.less';\n\n.section-title {\n    background-color: @secondary-25;\n    padding: 8px;\n    border-radius: @radius-sm;\n    color: @fg-primary;\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    min-height: 40px;\n\n\n    @media (max-width: 480px) {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    h4 {\n        margin: 0;\n        color: @fg-primary;\n        font-size: 16px;\n        font-weight: @font-weight-medium;\n    }\n\n    &-actions {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 1em;\n\n        .form-group {\n            margin: 0;\n            width: 100%;\n        }\n    }\n    // use in job edit view\n    .form-panel {\n        .section-title {\n            display: none;\n        }\n        .section-content {\n            .control-label {\n                display: none;\n            }\n            .form-group {\n                margin-bottom: 0;\n            }\n        }\n        .select2-container {\n            min-width: 180px;\n        }\n    }\n}",".section-title {\n  background-color: #FAFAFA;\n  padding: 8px;\n  border-radius: 6px;\n  color: #181D27;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  min-height: 40px;\n}\n@media (max-width: 480px) {\n  .section-title {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n.section-title h4 {\n  margin: 0;\n  color: #181D27;\n  font-size: 16px;\n  font-weight: 500;\n}\n.section-title-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1em;\n}\n.section-title-actions .form-group {\n  margin: 0;\n  width: 100%;\n}\n.section-title .form-panel .section-title {\n  display: none;\n}\n.section-title .form-panel .section-content .control-label {\n  display: none;\n}\n.section-title .form-panel .section-content .form-group {\n  margin-bottom: 0;\n}\n.section-title .form-panel .select2-container {\n  min-width: 180px;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
